import { ComponentProps, PropsWithChildren } from 'react'

import { IconPin } from '@avantstay/backoffice-vectors'

import { FilterIndicator } from '../FilterIndicator'
import { SortColumnIndicator, SortDirection } from '../SortColumnIndicator'
import * as S from './ColumnHeader.styles'

type FilterIndicatorProps = Pick<
  ComponentProps<typeof FilterIndicator>,
  'filterClassName' | 'filterComponent' | 'filterCount' | 'filterPlacement' | 'isFilterActive'
>

export interface ColumnHeaderProps extends PropsWithChildren, Partial<FilterIndicatorProps> {
  className?: string
  indicatorsAlwaysVisible?: boolean
  isPinned?: boolean
  onSort?: (direction: SortDirection) => void
  onTogglePin?: (pinned: boolean) => void
  sortColumnClassName?: string
  sortDirection?: SortDirection
  reversedOrder?: boolean
}

export const ColumnHeader = ({
  children,
  className,
  filterClassName,
  filterComponent,
  filterCount,
  filterPlacement,
  indicatorsAlwaysVisible,
  isFilterActive,
  isPinned,
  onSort,
  onTogglePin,
  sortColumnClassName,
  sortDirection,
  reversedOrder,
}: ColumnHeaderProps) => {
  return (
    <S.Root className={className}>
      {typeof children === 'string' ? (
        <S.EllipsisContainer>{children}</S.EllipsisContainer>
      ) : (
        children
      )}
      {onSort ? (
        <SortColumnIndicator
          sorting={sortDirection}
          onSort={onSort}
          reversedOrder={reversedOrder}
          alwaysVisible={indicatorsAlwaysVisible}
          className={sortColumnClassName}
        />
      ) : null}
      {filterComponent && (
        <FilterIndicator
          alwaysVisible={indicatorsAlwaysVisible}
          filterClassName={filterClassName}
          filterCount={filterCount}
          filterComponent={filterComponent}
          filterPlacement={filterPlacement}
          isFilterActive={isFilterActive}
        />
      )}
      {onTogglePin && (
        <S.PinnedIndicator
          $active={!!isPinned}
          onClick={() => onTogglePin(!isPinned)}
          title={isPinned ? 'Unpin column' : 'Pin column'}
        >
          <IconPin />
        </S.PinnedIndicator>
      )}
    </S.Root>
  )
}
